 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TP from '@/components/tp'
 import COP from '@/components/cop'
 import TOC from '@/components/toc'
 import ALSOBY from '@/components/alsoby'
 import CHAPTER1 from '@/components/chapter-1'
 import CHAPTER2 from '@/components/chapter-2'
 import CHAPTER3 from '@/components/chapter-3'
 import CHAPTER4 from '@/components/chapter-4'
 import NEXT from '@/components/next'
 import QUARTERS from '@/components/quarters'
 import TY from '@/components/ty'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/chapter-1",
 			"name" : "chapter-1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/chapter-2",
 			"name" : "chapter-2",
 			"component" : CHAPTER2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js